var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.42 1.99336C5.49741 1.91575 5.58937 1.85418 5.69061 1.81217C5.79185 1.77016 5.90039 1.74854 6.01 1.74854C6.11961 1.74854 6.22815 1.77016 6.32939 1.81217C6.43063 1.85418 6.52259 1.91575 6.6 1.99336L12.14 7.53336C12.2018 7.59503 12.2508 7.66829 12.2843 7.74894C12.3177 7.82959 12.335 7.91605 12.335 8.00336C12.335 8.09067 12.3177 8.17712 12.2843 8.25777C12.2508 8.33842 12.2018 8.41168 12.14 8.47336L6.6 14.0134C6.27333 14.34 5.74666 14.34 5.42 14.0134C5.09333 13.6867 5.09333 13.16 5.42 12.8334L10.2467 8.00002L5.41333 3.16669C5.09333 2.84669 5.09333 2.31336 5.42 1.99336Z",
    fill: "#828282"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrowRight.df2445d8ddaf3b40c39bc8a5ae6294b6.svg";
export { ForwardRef as ReactComponent };